// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3frZM","label":"Radio_label__204rd","checkMark":"Radio_checkMark__K7LeD","disabled":"Radio_disabled__27VXO"};